/**
 * The data attribute name for URL hash.
 *
 * @since 0.2.0
 */
export const HASH_ATTRIBUTE_NAME = 'data-splide-hash';
